// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.160Z

export const cards = [
  {
    "id": "syn_act_boevoy_stend",
    "name_ru": "Боевой стенд",
    "name_en": "Combat Rig",
    "faction": "syntetics",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Разыграй до 3 Модов из своей руки без урона Герою, все на одного выбранного юнита"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "play_mods_from_hand_free",
      "value": "count:3|target:single_ally|cost:0",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "3 импланта за раз. Один день жизни — это много.",
    "ability_text_en": {
      "order": "Play up to 3 Mods from your hand with no Hero damage, all onto a single chosen unit"
    }
  },
  {
    "id": "syn_act_bolshoy_peredel",
    "name_ru": "Большой передел",
    "name_en": "Great Reset",
    "faction": "syntetics",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь всею юнитов на поле, если у тебя есть 4 юнита"
    },
    "dsl_order": {
      "target": "all_units_on_field",
      "effect": "destroy_all_units_if_condition",
      "value": "condition:4_plus_own_units_with_mods",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда хорошо — продолжай. Когда плохо — стирай всех.",
    "ability_text_en": {
      "order": "Destroy all units on the field if you have 4 units"
    }
  },
  {
    "id": "syn_act_bonya_v_podvale",
    "name_ru": "Бойня в подвале",
    "name_en": "Slaughter in the Basement",
    "faction": "syntetics",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает Неистовство до конца хода; затем извлеки 2 случайных Мода из колоды и разыграй их на 2 разных твоих союзников без урона Герою"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "give_keyword:frenzy@hero_self|extract_random_mods_from_deck_play_on_allies:count:2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Подвал не сдаёт в аренду. Подвал кормят.",
    "ability_text_en": {
      "order": "The Hero gains Frenzy until end of turn; then draw 2 random Mods from the deck and play them onto 2 different allies of yours with no Hero damage"
    }
  },
  {
    "id": "syn_act_boytsovsky_klub",
    "name_ru": "Бойцовский клуб",
    "name_en": "Fight Club",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Всем твоим юнитам с хотя бы 1 Модом дай +1/0/0 и Неистовство до конца хода"
    },
    "dsl_order": {
      "target": "allies_with_mod",
      "effect": "composite",
      "value": "buff_temp:1/0/0|give_keyword:frenzy",
      "keyword": "frenzy",
      "duration": "1_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Первое правило бойцовского клуба — про второй имплант не говорим.",
    "ability_text_en": {
      "order": "Give all your units that have at least 1 Mod +1/0/0 and Frenzy until end of turn"
    }
  },
  {
    "id": "syn_act_dozapravka",
    "name_ru": "Дозаправка",
    "name_en": "Refuel",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Посмотри 3 случайных Мода из своей колоды; разыграй 1 на выбор, остальные 2 в сброс"
    },
    "dsl_order": {
      "target": "self",
      "effect": "look_at_random_mods_in_deck_pick_one",
      "value": "look:3|pick:1|to_hand|rest_to_discard",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Нашёл колоду — заглотил всю.",
    "ability_text_en": {
      "order": "Look at 3 random Mods from your deck; play 1 of your choice, the other 2 go to the discard"
    }
  },
  {
    "id": "syn_act_drachka",
    "name_ru": "Уличная драка",
    "name_en": "Street Fight",
    "faction": "syntetics",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все твои юниты получают +1/0/0 до конца хода"
    },
    "dsl_order": {
      "target": "all_allies",
      "effect": "buff_temp",
      "value": "1/0/0",
      "duration": "1_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Никто не строит, никто не командует. Все просто бьют.",
    "ability_text_en": {
      "order": "All your units get +1/0/0 until end of turn"
    }
  },
  {
    "id": "syn_act_elektroknut",
    "name_ru": "Удар электрокнутом",
    "name_en": "Electrolash Strike",
    "faction": "syntetics",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "2 урона выбранной цели; если цель — твой союзник, он получает +2/0/0 до конца игры"
    },
    "dsl_order": {
      "target": "enemy_or_ally_choose",
      "effect": "composite",
      "value": "damage:2@target|buff_perm:2/0/0@target_if_ally",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Боль одна для всех — что для своих, что для чужих.",
    "ability_text_en": {
      "order": "2 damage to a chosen target; if the target is your ally, it gets +2/0/0 for the rest of the game"
    }
  },
  {
    "id": "syn_act_implant_konveyer",
    "name_ru": "Имплантационный конвейер",
    "name_en": "Implantation Conveyor",
    "faction": "syntetics",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Дай 1 случайный Мод не из колоды каждому своему юниту на поле"
    },
    "dsl_order": {
      "target": "all_allies",
      "effect": "composite",
      "value": "generate_random_mod:1@allies_without_mods|generate_random_mod:1@allies_with_mods",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Линия не останавливается. Никто не выходит без улучшения.",
    "ability_text_en": {
      "order": "Give 1 random Mod (not from the deck) to each of your units on the field"
    }
  },
  {
    "id": "syn_act_implantatsia_v_podvale",
    "name_ru": "Имплантация в подвале",
    "name_en": "Backroom Implantation",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Разыграй до 2 Модов из своей руки на одного выбранного твоего союзника без урона Герою"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "play_mods_from_hand_free",
      "value": "count:2|target:single_ally|cost:0",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Подвал не лицензируют. Подвал работает.",
    "ability_text_en": {
      "order": "Play up to 2 Mods from your hand onto a single chosen ally with no Hero damage"
    }
  },
  {
    "id": "syn_act_konstruktor_implantov",
    "name_ru": "Конструктор имплантов",
    "name_en": "Implant Constructor",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Посмотри 4 случайных Мода из своей колоды; добавь 2 на выбор в руку; остальные - в сброс"
    },
    "dsl_order": {
      "target": "self",
      "effect": "look_at_random_mods_in_deck_pick_two",
      "value": "look:4|pick:2|to_hand|rest_to_discard",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не для слабых рук — для тех, кто умеет собирать.",
    "ability_text_en": {
      "order": "Look at 4 random Mods from your deck; add 2 of your choice to your hand; the rest go to the discard"
    }
  },
  {
    "id": "syn_act_oblava",
    "name_ru": "Облава",
    "name_en": "Raid",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси 1 урон всем юнитам на поле и 2 урона своему Герою"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "damage:1@all_units_on_field|damage:2@hero_self",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда нечего терять, бьют по всем.",
    "ability_text_en": {
      "order": "Deal 1 damage to all units on the field and 2 damage to your Hero"
    }
  },
  {
    "id": "syn_act_pech",
    "name_ru": "Печь",
    "name_en": "Furnace",
    "faction": "syntetics",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь всех своих юнитов н выбранной линии. Сумма их текущих атак распределяется случайно по 1 урону по всем персонажам противника"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "destroy_line_then_distribute_damage",
      "value": "destroy:all_own_units_on_chosen_line|distribute:sum_atk@enemy_persons_random",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Печь горит, потому что в ней горят. Сегодня — все.",
    "ability_text_en": {
      "order": "Destroy all your units on a chosen line. The sum of their current attacks is dealt as 1 damage each, randomly distributed among all enemy characters"
    }
  },
  {
    "id": "syn_act_pereproshivka",
    "name_ru": "Перепрошивка",
    "name_en": "Reflashing",
    "faction": "syntetics",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "У выбранного юнита появляется копия Мода, который на нём есть"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "duplicate_mods_on_target",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Один раз — мутант. Два раза — два мутанта в одной шкуре.",
    "ability_text_en": {
      "order": "A chosen unit gains a copy of a Mod it already has"
    }
  },
  {
    "id": "syn_act_rekvizitsiya",
    "name_ru": "Реквизиция",
    "name_en": "Requisition",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь своего юнита на поле, добери 2 карты из колоды, добавь 1 случайный Мод в руку"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "destroy:1@ally_choose|draw:2@self|generate_mod_to_hand:1@self",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Если этот человек тебе должен — забирай. Себя в счёт.",
    "ability_text_en": {
      "order": "Destroy one of your units on the field, draw 2 cards from your deck, add 1 random Mod to your hand"
    }
  },
  {
    "id": "syn_act_sdelka",
    "name_ru": "Грязная сделка",
    "name_en": "Dirty Deal",
    "faction": "syntetics",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Добери 2 карты, нанеси своему Герою 2 урона"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "draw:2@self|damage:2@hero_self",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Нет такого, чего нельзя купить. Цена — твоё лицо в новостях.",
    "ability_text_en": {
      "order": "Draw 2 cards, deal 2 damage to your Hero"
    }
  },
  {
    "id": "syn_act_shedevr_inzhenerii",
    "name_ru": "Шедевр инженерии",
    "name_en": "Engineering Masterpiece",
    "faction": "syntetics",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Возьми 1 любую карту типа Мод из своей колоды и сразу разыграй на выбранного твоего союзника без урона Герою"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "extract_chosen_mod_from_deck_play",
      "value": "player_choice|target:ally_choose|cost:0",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Один на тысячу попыток. Эта попытка.",
    "ability_text_en": {
      "order": "Take any Mod-type card from your deck and immediately play it onto a chosen ally with no Hero damage"
    }
  },
  {
    "id": "syn_act_stalnoy_kulak",
    "name_ru": "Стальной кулак",
    "name_en": "Steel Fist",
    "faction": "syntetics",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает +2/0/0 и Неистовство до конца хода"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "composite",
      "value": "buff_temp:2/0/0@hero_self|give_keyword:frenzy@hero_self",
      "keyword": "frenzy",
      "duration": "1_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда удар важнее точности — бей дважды.",
    "ability_text_en": {
      "order": "The Hero gets +2/0/0 and Frenzy until end of turn"
    }
  },
  {
    "id": "syn_act_stim",
    "name_ru": "Стим",
    "name_en": "Stim",
    "faction": "syntetics",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Юнит получает +2/0/1 и Неистовство на 2 хода."
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "composite",
      "value": "buff_temp:2/0/1@ally_choose|give_keyword:frenzy@ally_choose",
      "keyword": "frenzy",
      "duration": "2_turns"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Дозу — и ты на 5 минут великий. Потом — 5 минут не существуешь.",
    "ability_text_en": {
      "order": "A unit gets +2/0/1 and Frenzy for 2 turns."
    }
  },
  {
    "id": "syn_act_zhertvenny_krug",
    "name_ru": "Жертвенный круг",
    "name_en": "Sacrificial Circle",
    "faction": "syntetics",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь всех своих юнитов с атакой ≤2 на поле; за каждого уничтоженного добери 1 карту и нанеси по 2 урона стольким случайным вражеским юнитам, сколько уничтожил"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "destroy_all_own_with_atk_le_2|per_destroyed:draw:1+damage:2@enemy_unit_random",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда нужны карты, кровью платят слабые.",
    "ability_text_en": {
      "order": "Destroy all your units with attack ≤2 on the field; for each one destroyed, draw 1 card and deal 2 damage to as many random enemy units as you destroyed"
    }
  },
  {
    "id": "syn_augmented_giant",
    "name_ru": "Аугментированный гигант",
    "name_en": "Augmented Giant",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 4,
    "armor": 2,
    "hp": 8,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "получи 2 случайных Мода",
      "trigger": "На этом юните Сбой имплантов наступает при 4+ Модах"
    },
    "dsl_order": {
      "target": "self",
      "effect": "generate_random_mod_on_target",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self",
      "target": "self",
      "effect": "increase_mod_limit",
      "value": "1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Раньше был четыре раза человек. Теперь один раз — Гигант.",
    "ability_text_en": {
      "order": "Gain 2 random Mods",
      "trigger": "On this unit, Implant Failure triggers at 4+ Mods"
    }
  },
  {
    "id": "syn_bioenginer",
    "name_ru": "Биоинженер",
    "name_en": "Bioengineer",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 1,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда разыгрывается Мод, добери 1 карту из колоды"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "mod_played",
      "filter": "any",
      "target": "self_owner",
      "effect": "draw",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Каждый имплант — глава в его диссертации. У него много диссертаций.",
    "ability_text_en": {
      "trigger": "When a Mod is played, draw 1 card from your deck"
    }
  },
  {
    "id": "syn_biomeh",
    "name_ru": "Биомех",
    "name_en": "Biomech",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 1,
    "armor": 2,
    "hp": 5,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Каждый Мод на этом юните даёт +0/1/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self",
      "target": "self",
      "effect": "buff_self_per_mod_count",
      "value": "0/1/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не человек. Не машина. Не воин. Не считается.",
    "ability_text_en": {
      "trigger": "Each Mod on this unit grants +0/1/0"
    }
  },
  {
    "id": "syn_bishor_lich",
    "name_ru": "«Мясник» Бишор лично",
    "name_en": "Bishor in Person",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 5,
    "armor": 2,
    "hp": 7,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Получает +1/0/0 ща каждый розыгрыш Мода"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "mod_played",
      "filter": "any",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Где-то ещё ходит другой Бишор. Этот — настоящий.",
    "ability_text_en": {
      "trigger": "Gets +1/0/0 for each Mod played"
    }
  },
  {
    "id": "syn_chorny_rynok",
    "name_ru": "Чёрный рынок",
    "name_en": "Black Market",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 0,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти союзного юнита возьми 1 случайный Мод из колоды в руку"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "self",
      "effect": "generate_mod_to_hand",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда умер кто-то из своих, на рынке появляется новая запчасть.",
    "ability_text_en": {
      "trigger": "When an allied unit dies, take 1 random Mod from your deck into your hand"
    }
  },
  {
    "id": "syn_diler",
    "name_ru": "Дилер",
    "name_en": "Dealer",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "добавь 1 случайный Мод из своей колоды в руку."
    },
    "dsl_order": {
      "target": "self",
      "effect": "generate_mod_to_hand",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У него всегда есть свежий имплант. Цена варьируется от \"разговор\" до \"почка\".",
    "ability_text_en": {
      "order": "Add 1 random Mod from your deck to your hand."
    }
  },
  {
    "id": "syn_doctor_shram",
    "name_ru": "Доктор Шрам",
    "name_en": "Doctor Scar",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 3,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Герой получает +0/1/0 при розыгрыше Мода"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "mod_played",
      "filter": "any",
      "target": "hero_self",
      "effect": "buff_self_perm",
      "value": "0/1/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У Шрама на руках больше шрамов, чем кожи. У Босса больше брони, чем шрамов.",
    "ability_text_en": {
      "trigger": "The Hero gets +0/1/0 when a Mod is played"
    }
  },
  {
    "id": "syn_fixer",
    "name_ru": "Фиксер",
    "name_en": "Fixer",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "перенеси 1 Мод с одного твоего юнита на другого",
      "trigger": "В начале хода лечит сам себя на 0/0/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "self",
      "target": "self",
      "effect": "heal",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_choose",
      "effect": "transfer_mod_between_allies",
      "value": "1",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Он не друг и не враг. Он просто всегда между.",
    "ability_text_en": {
      "order": "Move 1 Mod from one of your units to another",
      "trigger": "At the start of the turn, heals itself for 0/0/1"
    }
  },
  {
    "id": "syn_gasper",
    "name_ru": "Гаспер",
    "name_en": "Gasper",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 5,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "3 урона Герою врага"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "hero_enemy",
      "effect": "damage",
      "value": "3",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Гаспер дышит мягко. Когда выдыхает — больше никого не остаётся.",
    "ability_text_en": {
      "deathrattle": "3 damage to the enemy Hero"
    }
  },
  {
    "id": "syn_glavar_bandy",
    "name_ru": "Главарь банды",
    "name_en": "Gang Leader",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 1,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "призови Дилера на случайную ячейку",
      "aura": "Пока юнит жив, юниты с Модом получают +1/0/0"
    },
    "dsl_order": {
      "target": "own_free_slot",
      "effect": "summon",
      "value": "syn_diler",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "allies_with_mod",
      "effect": "buff_stats",
      "value": "1/0/0"
    },
    "flavor_ru": "Где-то у него тоже был босс. Босса нет, банда есть.",
    "ability_text_en": {
      "order": "Summon a Dealer to a random slot",
      "aura": "While this unit is alive, units with a Mod get +1/0/0"
    }
  },
  {
    "id": "syn_hirurg_bez_litsenzii",
    "name_ru": "Хирург без лицензии",
    "name_en": "Unlicensed Surgeon",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда играется мод, получает -1 hp, а Герой хилится на 1 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "mod_played",
      "filter": "any",
      "target": "composite",
      "effect": "composite",
      "value": "damage:1@self|heal:1@hero_self_no_overheal",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Он шьёт, а вы не дёргайтесь.",
    "ability_text_en": {
      "trigger": "When a Mod is played, it takes -1 hp and the Hero heals 1 hp"
    }
  },
  {
    "id": "syn_hirurg_mehanik",
    "name_ru": "Хирург-механик",
    "name_en": "Mechanic Surgeon",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "лимит количества Модов на выбранном твоём союзнике увеличивается на 1"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "increase_mod_limit_on_target",
      "value": "1",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Без диплома. С опытом. Важно — не ошибиться в порядке проводов.",
    "ability_text_en": {
      "order": "The Mod limit on a chosen ally of yours increases by 1"
    }
  },
  {
    "id": "syn_implant_addikt",
    "name_ru": "Имплант-аддикт",
    "name_en": "Implant Addict",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 1,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "За каждый Мод на этом юните +0/0/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self",
      "target": "self",
      "effect": "buff_self_per_mod_count",
      "value": "0/0/2",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Чем больше — тем дольше живёт. Иногда — без памяти.",
    "ability_text_en": {
      "trigger": "For each Mod on this unit, +0/0/2"
    }
  },
  {
    "id": "syn_implantirovanny",
    "name_ru": "Имплантированный",
    "name_en": "Augmented",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 2,
    "armor": 1,
    "hp": 8,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Пока на этом юните есть хотя бы 1 Мод, в конце каждого хода он лечится на количество Модов на всех твоих юнитах"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "self",
      "target": "self",
      "effect": "heal_per_mod_count_on_field",
      "value": "count:all_mods_on_own_units",
      "duration": "oneshot",
      "condition": "self_has_at_least_one_mod"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда у целой банды импланты — дешевле всех лечить разом.",
    "ability_text_en": {
      "trigger": "While this unit has at least 1 Mod, at the end of each turn it heals for the total number of Mods on all your units"
    }
  },
  {
    "id": "syn_implantolog",
    "name_ru": "Имплантолог",
    "name_en": "Implantologist",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 1,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При розыгрыше Мода Герой хилится на 2 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "mod_played",
      "filter": "any",
      "target": "hero_self",
      "effect": "heal",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Каждый имплант — рана. Каждая рана — лекарство.",
    "ability_text_en": {
      "trigger": "When a Mod is played, the Hero heals 2 hp"
    }
  },
  {
    "id": "syn_implantoman",
    "name_ru": "Имплантоман",
    "name_en": "Implantomaniac",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 2,
    "armor": 2,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При розыгрыше Мода этот юнит получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "mod_played",
      "filter": "any",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Имплант он не использует — он его коллекционирует. На себе.",
    "ability_text_en": {
      "trigger": "When a Mod is played, this unit gets +1/0/0"
    }
  },
  {
    "id": "syn_kiberpsih",
    "name_ru": "Кибер-псих",
    "name_en": "Cyber-psycho",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Пока на этом юните есть хотя бы 1 Мод, он получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "aura_passive",
      "filter": "self",
      "target": "self",
      "effect": "conditional_buff_if_has_mod",
      "value": "1/0/0",
      "duration": "permanent",
      "condition": "self_has_at_least_one_mod"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Полтора метра нервов и проводов. Не разговаривает.",
    "ability_text_en": {
      "trigger": "While this unit has at least 1 Mod, it gets +1/0/0"
    }
  },
  {
    "id": "syn_konveyer_tel",
    "name_ru": "Конвейер тел",
    "name_en": "Body Conveyor",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 2,
    "armor": 0,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого хода создаёт копию случайного юнита из сброса со статами 1/0/1 на свободной клетке твоего поля"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "own_free_slot",
      "effect": "create_copy_of_random_unit_from_discard",
      "value": "stats:1/0/1|no_mods|no_triggers",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Тел много. Конвейер один.",
    "ability_text_en": {
      "trigger": "At the start of each turn, creates a copy of a random unit from the discard with 1/0/1 stats on a free slot of your field"
    }
  },
  {
    "id": "syn_lab_mutatsiy",
    "name_ru": "Лаборатория мутаций",
    "name_en": "Mutation Lab",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 0,
    "armor": 2,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда союзник получает Мод — 50% шанс: случайному вражескому юниту либо 3 урона, либо 1 случайный Мод"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_received_mod",
      "filter": "any",
      "target": "enemy_random",
      "effect": "roll_50_50_damage_or_random_mod_on_enemy",
      "value": "damage:3|mod:1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Лаборатория не выбирает между добром и злом. Она экспериментирует.",
    "ability_text_en": {
      "trigger": "When an ally gains a Mod — 50% chance: a random enemy unit takes either 3 damage or 1 random Mod"
    }
  },
  {
    "id": "syn_laborant_nii",
    "name_ru": "Лаборант НИИ",
    "name_en": "Lab Researcher",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 2,
    "armor": 1,
    "hp": 7,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого хода добавь 1 случайный Мод из своей колоды на случайного союзника"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "ally_choose",
      "effect": "draw_random_mod_from_deck_attach_to_ally",
      "value": "count:1|target:player_choice|cost:0",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Тестирует на себе. Плохо тестирует — потому пока живой.",
    "ability_text_en": {
      "trigger": "At the start of each turn, add 1 random Mod from your deck onto a random ally"
    }
  },
  {
    "id": "syn_loborganik",
    "name_ru": "Лоборганик",
    "name_en": "Lab-Organism",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 0,
    "armor": 0,
    "hp": 5,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого чётного хода даёт 1 случайный Мод каждому юниту на поле без Модов"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "all_allies_without_mods",
      "effect": "generate_random_mod_on_target",
      "value": "1",
      "duration": "oneshot",
      "condition": "turn_number_is_even"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Внешне — ошибка лаборатории. Внутри — её главный успех.",
    "ability_text_en": {
      "trigger": "At the start of each even turn, gives 1 random Mod to each unit on the field that has no Mods"
    }
  },
  {
    "id": "syn_mod_batareya",
    "name_ru": "Экспериментальная батарея",
    "name_en": "Experimental Battery",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "5 атак по 1 урону по 5 случайным юнитам на поле"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "all_units_on_field",
      "effect": "damage_split_random",
      "value": "5x1",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У всех есть лимит. У Батареи он короче, чем у её жертв.",
    "ability_text_en": {
      "deathrattle": "5 attacks of 1 damage each against 5 random units on the field"
    }
  },
  {
    "id": "syn_mod_boevoy_stim",
    "name_ru": "Боевой стим",
    "name_en": "Combat Stim",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 1,
    "armor": 0,
    "hp": 0,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Даёт +1/0/0. В начале каждого третьего хода Герой получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "hero_self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent",
      "condition": "turn_number_is_even+hero_is_bishor"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Имплант для двух человек: носитель чувствует силу, босс — её результат.",
    "ability_text_en": {
      "trigger": "Grants +1/0/0. At the start of every third turn, the Hero gets +1/0/0"
    }
  },
  {
    "id": "syn_mod_implant_berserka",
    "name_ru": "Имплант берсерка",
    "name_en": "Berserker Implant",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 2,
    "armor": 0,
    "hp": 0,
    "keywords": [
      "frenzy",
      "immune"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Даёт +2/0/0, Неистовство и Иммунитет. В конце каждого хода получает 2 урона"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "self",
      "target": "self",
      "effect": "damage",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда носитель забывает усталость, его тело тоже забывает что устало.",
    "ability_text_en": {
      "trigger": "Grants +2/0/0, Frenzy and Immune. At the end of each turn it takes 2 damage"
    }
  },
  {
    "id": "syn_mod_implant_mertvetsa",
    "name_ru": "Имплант мертвеца",
    "name_en": "Dead Man Implant",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 2,
    "armor": 0,
    "hp": 0,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "Даёт +2/0/0. Когда юнит-носитель умирает: Герой получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "hero_self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent",
      "condition": "hero_is_uein"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Мёртвые помогают живым. По мере сил.",
    "ability_text_en": {
      "deathrattle": "Grants +2/0/0. When the carrier unit dies: the Hero gets +1/0/0"
    }
  },
  {
    "id": "syn_mod_iskin",
    "name_ru": "Подключить искина",
    "name_en": "Plug In an AI",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода добавляет 1 случайный Мод из колоды в руку"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "self",
      "target": "self",
      "effect": "generate_mod_to_hand",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Маленький ИИ в твоей голове. Знает, что тебе нужно.",
    "ability_text_en": {
      "trigger": "At the end of the turn, adds 1 random Mod from the deck to your hand"
    }
  },
  {
    "id": "syn_mod_kamuflyazh",
    "name_ru": "Оптический камуфляж",
    "name_en": "Optical Camo",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Они тебя не видят. Они тебя слышат."
  },
  {
    "id": "syn_mod_krovavy_implant",
    "name_ru": "Кровавый имплант",
    "name_en": "Blood Implant",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 0,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Даёт +0/0/3. Когда юнит-носитель атакует, Герой получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "hero_self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent",
      "condition": "hero_is_bishor"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Кровь течёт через провод. Босс пьёт.",
    "ability_text_en": {
      "trigger": "Grants +0/0/3. When the carrier unit attacks, the Hero gets +1/0/0"
    }
  },
  {
    "id": "syn_mod_krovyanoy_nasos",
    "name_ru": "Кровяной насос",
    "name_en": "Blood Pump",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 0,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Даёт +0/0/2. В начале каждого хода юнит-носитель лечится на 2 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "self_carrier",
      "target": "self_carrier",
      "effect": "heal",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Качает быстрее, чем сердце. Хватит его потом — другой вопрос.",
    "ability_text_en": {
      "trigger": "Grants +0/0/2. At the start of each turn, the carrier unit heals 2 hp"
    }
  },
  {
    "id": "syn_mod_mehanodendrit",
    "name_ru": "Механодендрит",
    "name_en": "Mechanodendrite",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 0,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Третья рука хочет третий пистолет."
  },
  {
    "id": "syn_mod_ostry_vzglyad",
    "name_ru": "Острый взгляд",
    "name_en": "Sharp Eye",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Видит броню как бумагу."
  },
  {
    "id": "syn_mod_peregruz",
    "name_ru": "Перегруз рецепторов",
    "name_en": "Receptor Overload",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [
      "frenzy"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Бьёт два раза. Видит — три."
  },
  {
    "id": "syn_mod_stek_usilitel",
    "name_ru": "Стек-усилитель",
    "name_en": "Stack Amplifier",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 0,
    "armor": 0,
    "hp": 0,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода лечит других юнитов на 1 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "self_carrier_alive",
      "target": "all_allies",
      "effect": "heal",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Координирует регенерацию всей банды. Если работает.",
    "ability_text_en": {
      "trigger": "At the end of the turn, heals other units for 1 hp"
    }
  },
  {
    "id": "syn_mod_vtoroe_serdtse",
    "name_ru": "Второе сердце",
    "name_en": "Second Heart",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "юнит возвращается на ту же клетку с 1 hp в начале следующего хода"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "self",
      "effect": "resurrect_with_partial_hp",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Запасной двигатель для тех, кто не закончил.",
    "ability_text_en": {
      "deathrattle": "The unit returns to the same slot with 1 hp at the start of the next turn"
    }
  },
  {
    "id": "syn_mod_zashchitnaya_obolochka",
    "name_ru": "Защитная оболочка",
    "name_en": "Protective Shell",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 0,
    "armor": 2,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не имплант. Кожа. Только лучше."
  },
  {
    "id": "syn_mod_zaveshanie",
    "name_ru": "Цифровое завещание",
    "name_en": "Digital Will",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти юнита-носителя Герой получает 50% от hp юнита"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "self",
      "target": "composite",
      "effect": "composite",
      "value": "destroy:self|heal:self_max_hp_50%@hero_self",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Что нажил — отдал. Что отдал — кто-то выживет.",
    "ability_text_en": {
      "trigger": "When the carrier unit dies, the Hero gets 50% of the unit's hp"
    }
  },
  {
    "id": "syn_mod_zavodskoy",
    "name_ru": "Заводской имплант",
    "name_en": "Factory Implant",
    "faction": "syntetics",
    "type": "mod",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 1,
    "armor": 1,
    "hp": 1,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": "ally_choose",
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Даёт +1/1/1. Увеличивает лимит Модов на юните-носителе +1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self_carrier",
      "target": "self_carrier",
      "effect": "composite",
      "value": "increase_mod_limit:1|conditional_buff:2/0/0_if_2_plus_other_mods",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Простой, надёжный, никаких изысков. Идёт в комплекте с другими.",
    "ability_text_en": {
      "trigger": "Grants +1/1/1. Increases the Mod limit on the carrier unit by +1"
    }
  },
  {
    "id": "syn_naletchik",
    "name_ru": "Налётчик",
    "name_en": "Raider",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда атакует Героя, наносит +1 урон"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "hero_enemy",
      "effect": "extra_damage_on_attack",
      "value": "1",
      "duration": "oneshot",
      "condition": "target_is_enemy_hero"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не знает названия своей корпорации. Знает только, куда бить.",
    "ability_text_en": {
      "trigger": "When it attacks the Hero, deals +1 damage"
    }
  },
  {
    "id": "syn_narcolab",
    "name_ru": "Нарколаборатория",
    "name_en": "Drug Lab",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 0,
    "armor": 0,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого чётного хода даёт 1 случайный Мод (генерация) 1 случайному союнику"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "ally_random",
      "effect": "generate_random_mod_on_target",
      "value": "1",
      "duration": "oneshot",
      "condition": "turn_number_is_even"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Заходишь сам — выходишь не совсем.",
    "ability_text_en": {
      "trigger": "At the start of each even turn, gives 1 random Mod (generated) to 1 random ally"
    }
  },
  {
    "id": "syn_perekup",
    "name_ru": "Перекуп",
    "name_en": "Junker",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "возьми 1 случайную карту из своего сброса в руку"
    },
    "dsl_order": {
      "target": "self",
      "effect": "draw_from_discard",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Всё, что выкинули, у Перекупа стоит вдвое дороже.",
    "ability_text_en": {
      "order": "Take 1 random card from your discard into your hand"
    }
  },
  {
    "id": "syn_podpolny_boets",
    "name_ru": "Подпольный боец",
    "name_en": "Underground Fighter",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Не может атаковать пока на нём нет Мода"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self",
      "target": "self",
      "effect": "cannot_attack_if_no_mod",
      "duration": "permanent",
      "condition": "self_has_no_mod"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Без импланта он просто человек. С имплантом — машина.",
    "ability_text_en": {
      "trigger": "Cannot attack while it has no Mod"
    }
  },
  {
    "id": "syn_podryvnik",
    "name_ru": "Подрывник",
    "name_en": "Detonator",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "уничтожь своего юнита на поле, нанеси его атаку Герою врага"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "destroy_self_then_damage_hero",
      "value": "target_atk",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Подрывник умеет одно — нажимать. Кого взорвёт — решает босс.",
    "ability_text_en": {
      "order": "Destroy one of your units on the field and deal its attack to the enemy Hero"
    }
  },
  {
    "id": "syn_rast_lich",
    "name_ru": "«Грязный тактик» Раст лично",
    "name_en": "Rast in Person",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 3,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Когда любой юнит выставляется на стол, он получает 1 случайный Мод"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "ally_summoned",
      "effect": "attach_random_mod_extra",
      "value": "1"
    },
    "flavor_ru": "Там, где было два Раста, не остаётся ни одного человека.",
    "ability_text_en": {
      "aura": "When any unit is deployed, it gains 1 random Mod"
    }
  },
  {
    "id": "syn_shkurodyor",
    "name_ru": "Шкуродёр",
    "name_en": "Skinner",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 2,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "уничтожь своего юнита на поле, затем воскреси случайного юнита из своего сброса на случайную ячейку"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "composite",
      "value": "destroy:1@ally_choose|resurrect_random_from_discard:base_stats@own_free_slot",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Этот не лечит — он перешивает.",
    "ability_text_en": {
      "order": "Destroy one of your units on the field, then resurrect a random unit from your discard to a random slot"
    }
  },
  {
    "id": "syn_skvill_lich",
    "name_ru": "«Умняк» Сквилл лично",
    "name_en": "Squill in Person",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_skvill",
    "atk": 3,
    "armor": 2,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Сбой имплантов наступает при 7+ Модах. За каждый Мод на этом юните +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self",
      "target": "self",
      "effect": "composite",
      "value": "increase_mod_limit:4|buff_self_per_mod_count:1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Где-то ходит другой Сквилл, проектирует. Этот — носит результат.",
    "ability_text_en": {
      "trigger": "Implant Failure triggers at 7+ Mods. For each Mod on this unit, +1/0/0"
    }
  },
  {
    "id": "syn_smertnik",
    "name_ru": "Смертник",
    "name_en": "Suicide Bomber",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 4,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "2 урона Герою врага"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "hero_enemy",
      "effect": "damage",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Жил. Умер. Что между этим — никто не помнит.",
    "ability_text_en": {
      "deathrattle": "2 damage to the enemy Hero"
    }
  },
  {
    "id": "syn_spisany_dron",
    "name_ru": "Списанный дрон",
    "name_en": "Scrapped Drone",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Сбой имплантов наступает при 4+ Модах"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "passive_modifier",
      "filter": "self",
      "target": "self",
      "effect": "increase_mod_limit",
      "value": "1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Сбился с маршрута лет десять назад. Зачем-то остался у банды.",
    "ability_text_en": {
      "trigger": "Implant Failure triggers at 4+ Mods"
    }
  },
  {
    "id": "syn_stimulyatorshchik",
    "name_ru": "Стимуляторщик",
    "name_en": "Stimulator Pusher",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "твой Герой получает +1/0/0; наносит своему Герою 2 урона"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "buff_perm:1/0/0@hero_self|damage:2@hero_self",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Один укол — и босс перестаёт чувствовать удары. Два укола — и Босс перестаёт чувствовать.",
    "ability_text_en": {
      "order": "Your Hero gets +1/0/0; deals 2 damage to your Hero"
    }
  },
  {
    "id": "syn_temny_netrunner",
    "name_ru": "Тёмный нетраннер",
    "name_en": "Dark Netrunner",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Наносит 2 урона случайному вражескому юниту при получении урона союзником"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_or_hero_takes_damage",
      "filter": "any",
      "target": "enemy_random",
      "effect": "damage",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Он не воюет — он мстит. Каждый удар по своим — удар по чужим.",
    "ability_text_en": {
      "trigger": "Deals 2 damage to a random enemy unit when an ally takes damage"
    }
  },
  {
    "id": "syn_torchok",
    "name_ru": "Торчок",
    "name_en": "Druggie",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода: 1 урон случайному союзному юниту и 1 урон случайному вражескому юниту"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "any",
      "target": "composite",
      "effect": "composite",
      "value": "damage:1@ally_random|damage:1@enemy_random",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Что-то горит, что-то стреляет, кто-то кричит. Торчок счастлив.",
    "ability_text_en": {
      "trigger": "At the end of the turn: 1 damage to a random allied unit and 1 damage to a random enemy unit"
    }
  },
  {
    "id": "syn_tseh_implantov",
    "name_ru": "Цех имплантов",
    "name_en": "Implant Workshop",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_bishor",
    "atk": 0,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого чётного хода даёт юниту с наибольшим числом Модов ещё 1 случайный Мод"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "ally_random",
      "effect": "generate_random_mod_on_target",
      "value": "1",
      "duration": "oneshot",
      "condition": "turn_number_is_even"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Конвейер не останавливается. Даже если рабочих нет.",
    "ability_text_en": {
      "trigger": "At the start of each even turn, gives the unit with the most Mods 1 more random Mod"
    }
  },
  {
    "id": "syn_uein_lich",
    "name_ru": "Рипер Уэйн лично",
    "name_en": "Reaper Wayne in Person",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "syn_uein",
    "atk": 5,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти юнита добавь 1 случайный Мод и добери 1 карту"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "composite",
      "effect": "composite",
      "value": "generate_mod_to_hand:1@self|draw:1@self",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Где-то ходит другой Уэйн, считает чужие смерти. Этот — считает свои.",
    "ability_text_en": {
      "trigger": "When a unit dies, add 1 random Mod and draw 1 card"
    }
  },
  {
    "id": "syn_ulichny_naemnik",
    "name_ru": "Уличный наёмник",
    "name_en": "Street Mercenary",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда союзник получает мод, этот юнит +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_received_mod",
      "filter": "any",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Платят имплантами. Берёт всё.",
    "ability_text_en": {
      "trigger": "When an ally gains a Mod, this unit gets +1/0/0"
    }
  },
  {
    "id": "syn_vyshibala",
    "name_ru": "Вышибала",
    "name_en": "Bouncer",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 3,
    "hp": 5,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У него только одна работа. И он её знает."
  },
  {
    "id": "syn_zazyvala",
    "name_ru": "Зазывала",
    "name_en": "Crier",
    "faction": "syntetics",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "syn_rast",
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "посмотри 3 случайных Мода из своей колоды. Выбери 1 и наложи на любого твоего союзника без штрафа. Остальные 2 в сброс"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "look_at_random_mods_in_deck_attach_one",
      "value": "look:3|pick:1|attach_to:ally_choose|cost:0",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Кричит на каждом углу. Имплант — каждому. Бесплатно. Сегодня.",
    "ability_text_en": {
      "order": "Look at 3 random Mods from your deck. Pick 1 and attach it to any of your allies with no penalty. The other 2 go to the discard"
    }
  }
];
